import React, { useState } from 'react';
import OrderReturnPage from './components/OrderReturnPage';
import { returnOrderStatus } from '../../../constants/orderStatus';

const Received = () => {
  const bulkActionOptions = [
    {
      label: 'QC Pass',
      value: 'qcpass',
    },
    {
      label: 'Refund Completed',
      value: 'earlyRefund',
    },
  ];

  const defaultConfirmationProps = {
    qcPassed: [
      {
        type: 'text',
        title: 'Serial No.',
        value: '',
      },
    ],
    earlyRefund: [
      {
        type: 'date',
        title: 'Transaction Date',
        value: '',
      },
      {
        type: 'text',
        title: 'Amount',
        value: '',
      },
      {
        type: 'text',
        title: 'Transaction No.',
        value: '',
      },
      {
        type: 'text',
        title: 'Mode',
        value: '',
      },
      {
        type: 'textArea',
        title: 'Remarks',
        value: '',
      },
    ],
  };
  const [confirmationModalProps, setConfirmationModalProps] = useState([]);

  return (
    <>
      <OrderReturnPage
        type={returnOrderStatus.RECEIVED}
        bulkActionOptions={bulkActionOptions}
        defaultConfirmationProps={defaultConfirmationProps}
        confirmationModalProps={confirmationModalProps}
        setConfirmationModalProps={setConfirmationModalProps}
      />
    </>
  );
};

export default Received;
